import { TextLink } from "nystem-components";

const IntLink = (props) => <TextLink {...props} />;
export default IntLink;
